<div class="step-side-form-container">
  <div class="signup-form-container mobile-setup">
    <div class="step-header">Get the Synced mobile app</div>
    <div class="step-header-second">
      Snap receipts on the go — Synced auto-captures the merchant, date, and amount, and pushes them into your workspace.
    </div>

    <div class="mobile-setup__badges">
      <button type="button" class="mobile-setup__badge" (click)="appStore()">
        <span class="mobile-setup__platform">Download on the</span>
        <span class="mobile-setup__store">App Store</span>
      </button>
      <button type="button" class="mobile-setup__badge" (click)="playStore()">
        <span class="mobile-setup__platform">Get it on</span>
        <span class="mobile-setup__store">Google Play</span>
      </button>
    </div>

    <div class="mobile-setup__actions">
      <button type="button" class="signup__btn-next" (click)="continue()">I've downloaded it</button>
    </div>
  </div>
</div>
